import Testimonial from "."; 

export const testimonialsRoutes = () => [
  {
    path: "/testimonials",
    component: Testimonial,
    layout: "front",
    title: "page",
  },
];